var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMp4PlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.91,
    height: 37.91,
    viewBox: "0 0 37.91 37.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "playa",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6788",
    "data-name": "Path 6788",
    d: "M19.955,37.91A17.955,17.955,0,1,0,2,19.955,17.955,17.955,0,0,0,19.955,37.91Z",
    fill: "none",
    stroke: "#0052cc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6789",
    "data-name": "Path 6789",
    d: "M9.5,9.8c0-.857,0-1.285.179-1.525a.9.9,0,0,1,.655-.357c.3-.021.658.21,1.379.674l8.476,5.449c.626.4.938.6,1.046.859a.9.9,0,0,1,0,.7c-.108.256-.421.457-1.046.859l-8.476,5.449c-.721.463-1.081.7-1.379.674a.9.9,0,0,1-.655-.357C9.5,21.983,9.5,21.554,9.5,20.7Z",
    transform: "translate(5.966 4.707)",
    fill: "#0052cc",
    stroke: "#0052cc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp4PlayIcon);
export default __webpack_public_path__ + "static/media/mp4PlayIcon.87253a32f339187cfaafcdbf9c607cbb.svg";
export { ForwardRef as ReactComponent };